const swiperEstateBlock = new Swiper(".estate__block__slider", {
  loop: false,
  spaceBetween: 20,
  slidesPerView: 3,
  speed: 800,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".estate__block__slider-next",
    prevEl: ".estate__block__slider-prev",
  },
});

const estateBlockButton = document.querySelector('.estate__block__tag__button');

if (estateBlockButton) {
    estateBlockButton.addEventListener('click', () => {
        document.querySelector('.estate__block__tag').classList.toggle('active');
    });
}

// const tagEstateBlock = document.querySelector('.estate__block__tag');
// if (tagEstateBlock) {
//     const buttons = tagEstateBlock.querySelectorAll('[data-button]');
//     const slides = document.querySelectorAll('.estate__block__slider .swiper-slide');
//     const swiperEl = document.querySelector('.estate__block__slider.swiper');
//     const swiper = swiperEl?.swiper;
    
//     const handleSliderByScreenSize = () => {
//         if (window.innerWidth > 991) {

//             if (swiper && swiper.initialized) {
//                 swiper.update();
//             } else if (swiperEl && !swiperEl.swiper) {
//                 if (typeof Swiper !== 'undefined') {
//                     new Swiper(swiperEl, {
//                         slidesPerView: 'auto',
//                         spaceBetween: 20,
//                         navigation: {
//                             nextEl: '.estate__block__slider-next',
//                             prevEl: '.estate__block__slider-prev',
//                         },
//                     });
//                 }
//             }
//         } else {
//             if (swiper && swiper.destroy && typeof swiper.destroy === 'function') {
//                 swiper.destroy(true, true);
//             }
//         }
//     };
    
//     const filterSlides = (filterValue) => {
//         slides.forEach(slide => {
//             const slideValue = slide.getAttribute('data-slide');
//             if (filterValue === 'all' || slideValue === filterValue) {
//                 slide.style.display = '';
//             } else {
//                 slide.style.display = 'none';
//             }
//         });
        
//         if (window.innerWidth > 991 && swiper && typeof swiper.update === 'function') {
//             swiper.update();
//             swiper.slideTo(0);
//         }
//     };
    
//     const initActiveFilter = () => {
//         const activeButton = tagEstateBlock.querySelector('[data-button].active');
//         if (activeButton) {
//             const initialFilterValue = activeButton.getAttribute('data-button');
//             filterSlides(initialFilterValue);
//         }
//     };
    
//     handleSliderByScreenSize();
//     initActiveFilter();
    
//     buttons.forEach(button => {
//         button.addEventListener('click', event => {
//             event.preventDefault();
            
//             buttons.forEach(btn => btn.classList.remove('active'));
//             button.classList.add('active');
            
//             const filterValue = button.getAttribute('data-button');
//             filterSlides(filterValue);
//         });
//     });
    
//     let resizeTimeout;
//     window.addEventListener('resize', () => {
//         clearTimeout(resizeTimeout);
//         resizeTimeout = setTimeout(() => {
//             handleSliderByScreenSize();
            
//             const activeButton = tagEstateBlock.querySelector('[data-button].active');
//             if (activeButton) {
//                 const filterValue = activeButton.getAttribute('data-button');
//                 filterSlides(filterValue);
//             }
//         }, 250); 
//     });
// }

const tagEstateBlock = document.querySelector('.estate__block__tag');
if (tagEstateBlock) {
    const buttons = tagEstateBlock.querySelectorAll('[data-button]');
    const slides = document.querySelectorAll('.estate__block__slider .swiper-slide');
    const swiperEl = document.querySelector('.estate__block__slider.swiper');
    const swiper = swiperEl?.swiper;
    
    const getSlideLimit = () => {
        const width = window.innerWidth;
        if (width < 768) {
            return 3; 
        } else if (width >= 768 && width <= 991) {
            return 4; 
        } else {
            return Infinity; 
        }
    };
    
    const handleSliderByScreenSize = () => {
        if (window.innerWidth > 991) {
            if (swiper && swiper.initialized) {
                swiper.update();
            } else if (swiperEl && !swiperEl.swiper) {
                if (typeof Swiper !== 'undefined') {
                    new Swiper(swiperEl, {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        navigation: {
                            nextEl: '.estate__block__slider-next',
                            prevEl: '.estate__block__slider-prev',
                        },
                    });
                }
            }
        } else {
            if (swiper && swiper.destroy && typeof swiper.destroy === 'function') {
                swiper.destroy(true, true);
            }
        }
    };
    
    const filterSlides = (filterValue) => {
        const slideLimit = getSlideLimit();
        const isDesktop = window.innerWidth > 991;
        let visibleCount = 0;
        
        slides.forEach(slide => {
            slide.style.display = 'none';
        });
        
        slides.forEach(slide => {
            const slideValue = slide.getAttribute('data-slide');
            const shouldShow = filterValue === 'all' || slideValue === filterValue;
            
            if (shouldShow) {
                if (isDesktop) {
                    slide.style.display = '';
                } else {
                    if (visibleCount < slideLimit) {
                        slide.style.display = '';
                        visibleCount++;
                    }
                }
            }
        });
        
        if (isDesktop && swiper && typeof swiper.update === 'function') {
            swiper.update();
            swiper.slideTo(0);
        }
    };
    
    const initActiveFilter = () => {
        const activeButton = tagEstateBlock.querySelector('[data-button].active');
        if (activeButton) {
            const initialFilterValue = activeButton.getAttribute('data-button');
            filterSlides(initialFilterValue);
        }
    };
    
    handleSliderByScreenSize();
    initActiveFilter();
    
    buttons.forEach(button => {
        button.addEventListener('click', event => {
            event.preventDefault();
            
            buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            
            const filterValue = button.getAttribute('data-button');
            filterSlides(filterValue);
        });
    });
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            handleSliderByScreenSize();
            
            const activeButton = tagEstateBlock.querySelector('[data-button].active');
            if (activeButton) {
                const filterValue = activeButton.getAttribute('data-button');
                filterSlides(filterValue);
            }
        }, 250);
    });
}